import { render, staticRenderFns } from "./ViewMonitoringFeatures.vue?vue&type=template&id=2e24f0bb"
import script from "./ViewMonitoringFeatures.vue?vue&type=script&lang=js"
export * from "./ViewMonitoringFeatures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports